import { createSlice } from '@reduxjs/toolkit';

const documentsSlice = createSlice({
    name: 'documents',
    initialState: { selectedDocument: null, userDocuments: null },

    reducers: {
        setSelectedDocument: (state, action) => {
            //add selected document to state
            state.selectedDocument = action.payload;
        },
        clearSelectedDocument: (state) => {
            state.selectedDocument = null;
        },
        setUserDocuments: (state, action) => {
            state.userDocuments = action.payload;
        },
        clearUserDocuments: (state) => {
            state.userDocuments = []
        },
    },
});

export const {
    setSelectedDocument,
    clearSelectedDocument,
    setUserDocuments,
    clearUserDocuments,
} = documentsSlice.actions;
export default documentsSlice.reducer;
